import React from 'react';
import { MapPin } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Location() {
  const { t } = useLanguage();

  return (
    <section id="location" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm tracking-[0.3em] uppercase text-[#b8945e] font-medium mb-4">{t.location.eyebrow}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mb-3">{t.location.title}</h2>
          <p className="text-lg text-stone-600">{t.location.subtitle}</p>
          <div className="w-20 h-px bg-[#b8945e] mx-auto mt-6" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-stretch">
          <div className="rounded-3xl overflow-hidden shadow-2xl min-h-[500px] bg-stone-100">
            <iframe
              title="Moonlit Villa location"
              src="https://www.google.com/maps?q=Planos,+Zakynthos,+Greece&output=embed"
              className="w-full h-full min-h-[500px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="bg-[#faf6ef] rounded-3xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {t.location.places.map((p, i) => (
                <div key={i} className="group flex items-center justify-between p-4 bg-white rounded-xl hover:shadow-md transition-all border border-stone-100">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-[#b8945e]/10 flex items-center justify-center group-hover:bg-[#b8945e] transition-colors">
                      <MapPin size={16} className="text-[#b8945e] group-hover:text-white transition-colors" />
                    </div>
                    <span className="text-stone-800 font-medium text-sm">{p.name}</span>
                  </div>
                  <span className="text-[#b8945e] font-semibold text-sm">{p.dist}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
